import React from 'react';
import { useEffect, useState, useRef } from 'react';
import useNotifications from "../hooks/useNotifications";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { userManualDownloadUrl, visitorRegistrationLink, disclaimer, link_BASE_URL } from '../utils/constants';
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import NotificationMeta from "./NotificationMeta";
import StepHeader from '../screens/registration/stepHeader'
import ExhibitorTopMenu from "../common_components/exhibitor_module_topmenu";


// Modal.setAppElement("#root");


// {head,subHeader}
const VisitorHeader2 = () => {
    const navigate = useNavigate();

    // const history = useNavigate();
    const [isLoading, setLoader] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
    const marqueeRef = useRef(null);
    const notificationRef = useRef(null);

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js',
        //   'js/azia.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }

    // useEffect(() => {
    //     loadScripts();
    //     // console.log("sessionStorage.getItem(sessionExhibitorDrawerData)------->", sessionStorage.getItem(sessionExhibitorDrawerData))

    // }, []);


    const openPdf = () => {
        var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
        window.open(URL, null);
    }

    const address = sessionStorage.getItem('ExhibitionAddressSS')

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onLogoutClick = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    };

    const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";

    const profileRef = useRef(null);
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");

    useEffect(() => {
        function handleClickOutside(event) {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfile(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const visitorRegistrationLinkHeader = `${link_BASE_URL}visitorregistration/${sessionStorage.getItem("exhibitionCode")}`

    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <>

                {isMobileMenuOpen && (
                    <div
                        className="mobile-menu-overlay exhibitor-mobile-overlay"
                        onClick={closeMobileMenu}
                    ></div>
                )}


                <div
                    className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
                        }`}
                >
                    <div className="mobile-menu-content p-3" style={{ backgroundColor: '#f8f9fa', height: '100%', overflowY: 'auto' }}>
                        {/* Header area with Name and Close button */}
                        <div className="card border-0 shadow-sm rounded-3 mb-3" style={{ backgroundColor: '#3cbba7' }}>
                            <div className="card-body p-3 d-flex justify-content-between align-items-start">
                                <div className="text-start">
                                    <div className="text-white-50" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>WELCOME,</div>
                                    <div className="fw-bold text-white fs-5 lh-1 mt-1">{sessionStorage.getItem("firstNameSS")}</div>
                                </div>
                                <button onClick={closeMobileMenu} className="btn btn-sm btn-link text-white p-0 mt-1">
                                    <i className="fa fa-times fa-lg"></i>
                                </button>
                            </div>
                        </div>

                        {/* Card 1: Notifications */}
                        <div className="card border-0 shadow-sm rounded-3 mb-3">
                            <div className="card-body p-3">
                                <div className="d-flex align-items-center mb-3 border-bottom pb-2">
                                    <i className="fa fa-bell-o text-success me-2"></i>
                                    <span className="text-muted fw-bold" style={{ fontSize: '11px', letterSpacing: '1px' }}>NOTIFICATIONS</span>
                                </div>
                                {notifications.length === 0 ? (
                                    <div className="bg-light rounded p-2 text-center text-muted small">No notifications</div>
                                ) : notifications.slice(0, 2).map(n => (
                                    <div key={n.id} className="d-flex justify-content-between align-items-center bg-light rounded p-2 mb-2" style={{ cursor: 'pointer' }} onClick={() => { openPreview(n.id); closeMobileMenu(); }}>
                                        <div className="d-flex align-items-start">
                                            <div className="bg-secondary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 mt-1" style={{ width: '20px', height: '20px' }}>
                                                <i className={`fa ${n.type === 'alert' ? 'fa-exclamation' : 'fa-bell-o'} text-muted`} style={{ fontSize: '10px' }}></i>
                                            </div>
                                            <span className="text-muted lh-sm" style={{ fontSize: '12px', fontWeight: '500' }}>
                                                <span dangerouslySetInnerHTML={{ __html: n.title }}></span>
                                            </span>
                                        </div>
                                        <span className="text-success fw-bold ms-2" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>VIEW &gt;</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Card 2: Exhibition Details */}
                        <div className="card border-0 shadow-sm rounded-3 mb-3">
                            <div className="card-body p-3">
                                <div className="d-flex align-items-center mb-3 border-bottom pb-2">
                                    <i className="fa fa-calendar-check-o text-success me-2"></i>
                                    <span className="text-muted fw-bold" style={{ fontSize: '11px', letterSpacing: '1px' }}>EXHIBITION DETAILS</span>
                                </div>
                                <div className="mb-3 text-start">
                                    <div className="text-success fw-bold mb-1" style={{ fontSize: '10px', letterSpacing: '1px' }}>DATE</div>
                                    <div className="fw-semibold" style={{ fontSize: '14px' }}>{sessionStorage.getItem("ExhibitionFromDateSS")} - {sessionStorage.getItem("ExhibitionToDateSS")}</div>
                                </div>
                                <div className="text-start">
                                    <div className="text-success fw-bold mb-1" style={{ fontSize: '10px', letterSpacing: '1px' }}>LOCATION</div>
                                    <div className="d-flex align-items-start">
                                        <i className="bi bi-geo-alt text-muted mt-1 me-2"></i>
                                        <span className="text-muted" style={{ fontSize: '13px', fontWeight: '500' }}>{address}</span>
                                    </div>
                                </div>
                                <div className="text-end mt-3 border-top pt-2">
                                    <a href={corporateLink} target="_blank" rel="noopener noreferrer" className="text-success text-decoration-none fw-bold" style={{ fontSize: '11px' }}>
                                        Corporate Site <i className="bi bi-box-arrow-up-right ms-1"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Change Password Button */}
                        <Link
                            to="/Change_Password"
                            onClick={closeMobileMenu}
                            className="btn w-100 fw-semibold border-0 mb-2 d-flex justify-content-center align-items-center"
                            style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', padding: '12px', borderRadius: '8px', textDecoration: 'none' }}
                        >
                            <i className="fa fa-lock me-2"></i> Change Password
                        </Link>

                        {/* Sign Out Button */}
                        <button
                            onClick={() => { closeMobileMenu(); onLogoutClick(); }}
                            className="btn w-100 fw-semibold border-0 mb-4 d-flex justify-content-center align-items-center"
                            style={{ backgroundColor: '#ffe5e5', color: '#d32f2f', padding: '12px', borderRadius: '8px' }}
                        >
                            <i className="fa fa-power-off me-2"></i> Sign Out
                        </button>
                    </div>
                </div>


                <div className="app-header header sticky app-heder-with-logo pt-0 visitor-header-light">
                    <div className="container-fluid main-container px-2 px-md-3">
                        <div className="d-flex align-items-center justify-content-between">
                            {/* LOGO */}
                            <div className="side-header top-logo-almnt d-flex align-items-center justify-content-center" style={{ padding: '0', margin: '0' }}>
                                <img
                                    src={sessionStorage.getItem("ExhibitionLogoSS")}
                                    alt="logo"
                                    style={{ height: '60px', objectFit: 'contain', margin: '0 auto' }}
                                />
                            </div>

                            {/* EXHIBITION INFO: plain text on tablets */}
                            <h5 className="exbheader text-white d-none d-md-block d-xl-none">
                                {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
                                {sessionStorage.getItem("ExhibitionToDateSS")} <br />
                                {sessionStorage.getItem("ExhibitionAddressSS")}
                            </h5>

                            {/* EXHIBITION INFO: desktop, same icon-tile layout as the visitor header */}
                            {(() => {
                                const address = sessionStorage.getItem("ExhibitionAddressSS") || ''
                                const comma = address.indexOf(',')
                                let mobiles = [], emails = []
                                try { mobiles = JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo')) || [] } catch (e) { }
                                try { emails = JSON.parse(sessionStorage.getItem('sessionExhibitionEmail')) || [] } catch (e) { }
                                return (
                                    // This header has no top padding (pt-0), so start 8px down instead of the shared -6px nudge
                                    <div className="vh-info d-none d-xl-flex me-auto" style={{ justifyContent: 'flex-start', paddingLeft: 12, marginTop: 8 }}>
                                        <div className="vh-block" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                                            <div className="vh-row" style={{ justifyContent: 'flex-start', width: '100%' }}>
                                                <span className="vh-icon"><i className="fa fa-calendar"></i></span>
                                                <strong className="vh-date">{sessionStorage.getItem("ExhibitionFromDateSS")} - {sessionStorage.getItem("ExhibitionToDateSS")}</strong>
                                            </div>
                                            <div className="vh-row" style={{ justifyContent: 'flex-start', width: '100%' }}>
                                                <span className="vh-icon"><i className="fa fa-map-marker"></i></span>
                                                <span className="vh-address">
                                                    {comma > -1 ? <><strong>{address.slice(0, comma + 1)}</strong>{address.slice(comma + 1)}</> : address}
                                                </span>
                                            </div>
                                        </div>
                                        {(mobiles.length > 0 || emails.length > 0) && <>
                                            <span className="vh-divider"></span>
                                            <div className="vh-block" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                                                <div className="vh-row">
                                                    <span className="vh-icon vh-icon-round"><i className="fa fa-headphones"></i></span>
                                                    <div>
                                                        <div className="vh-label">For Assistance</div>
                                                        <div className="vh-contact">
                                                            {mobiles.length > 0 && <strong className="vh-phone">{mobiles.join(', ')}</strong>}
                                                            {emails.length > 0 && (
                                                                <span className="vh-email">
                                                                    <i className="fa fa-envelope-o"></i>
                                                                    {emails.map((data, i) => (
                                                                        <a key={i} href={`mailto:${data}`}>{data}{i != emails.length - 1 ? ' / ' : ''}</a>
                                                                    ))}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                    </div>
                                )
                            })()}

                            {/* NOTIFICATION BELL + PROFILE ICON */}
                            <div className="d-flex align-items-center gap-2 pe-1">
                                {/* Corporate Site Button */}
                                <a
                                    href={corporateLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-light rounded-pill d-none d-md-block"
                                    style={{ fontWeight: '500', padding: '5px 15px' }}
                                >
                                    Corporate Site
                                </a>

                                {/* <div className="notification-bell-wrapper" ref={notificationRef} style={{ marginTop: '4px' }}>
                                <i
                                    className="fa fa-bell fa-lg text-white"
                                    onClick={() => { setShowNotifications(!showNotifications); setShowProfile(false); }}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                                {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                                {showNotifications && (
                                    <div className="notification-dropdown shadow">
                                        <div className="notification-dropdown-header">
                                            <span>Notifications</span>
                                            {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                                        </div>
                                        {notifications.length === 0 ? (
                                            <div className="notification-empty"><i className="fa fa-bell-slash-o"></i><br />No notifications</div>
                                        ) : notifications.slice(0, 3).map(n => (
                                            <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                                                <span className={`notification-item-icon ${n.type}`}>
                                                    {n.initial}
                                                </span>
                                                <div className="notification-item-content">
                                                    <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                                                    <NotificationMeta notification={n} />
                                                    {n.time && <div className="notification-item-time">{n.time}</div>}
                                                </div>
                                                <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                                            </div>
                                        ))}
                                        <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                                    </div>
                                )}
                            </div> */}

                                {/* PROFILE ICON */}
                                <div className="position-relative" ref={profileRef}>
                                    <i
                                        className="fa fa-user-circle fa-2x text-white "
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowProfile(!showProfile)}
                                    ></i>

                                    {/* PROFILE DROPDOWN */}
                                    {showProfile && (
                                        <div className="profile-dropdown profile-menu">
                                            <div className="profile-menu-head">
                                                <span className="profile-menu-avatar">
                                                    {(sessionStorage.getItem("firstNameSS") || "?").trim().charAt(0).toUpperCase()}
                                                </span>
                                                <span className="profile-menu-name">{sessionStorage.getItem("firstNameSS")}</span>
                                            </div>

                                            <div className="profile-menu-section">
                                                <div className="profile-menu-title">Quick Links</div>
                                                <a
                                                    href={corporateLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="profile-menu-item"
                                                    onClick={() => { closeMobileMenu(); setShowProfile(false); }}
                                                >
                                                    <i className="fa fa-globe"></i>
                                                    <span>Corporate Site</span>
                                                    <i className="fa fa-external-link profile-menu-trail"></i>
                                                </a>
                                                <a
                                                    href={visitorRegistrationLinkHeader}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="profile-menu-item"
                                                    onClick={() => setShowProfile(false)}
                                                >
                                                    <i className="fa fa-share-alt"></i>
                                                    <span>Share Link</span>
                                                    <i className="fa fa-external-link profile-menu-trail"></i>
                                                </a>
                                            </div>

                                            <div className="profile-menu-section profile-menu-divider">
                                                <Link
                                                    to="/Change_Password"
                                                    className="profile-menu-item"
                                                    onClick={() => setShowProfile(false)}
                                                >
                                                    <i className="fa fa-lock"></i>
                                                    <span>Change Password</span>
                                                </Link>
                                                <button
                                                    type="button"
                                                    className="profile-menu-item profile-menu-logout"
                                                    onClick={onLogoutClick}
                                                >
                                                    <i className="fa fa-sign-out"></i>
                                                    <span>Logout</span>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>{/* end bell+profile group */}
                        </div>

                        {/* Absolute Marquee at the bottom of the header */}
                        <div className="marquee-text" style={{ position: 'absolute', bottom: '-4px', left: '0', width: '100%', pointerEvents: 'none', margin: '0' }}>
                            <marquee
                                behavior="scroll"
                                direction="left"
                                scrollamount="5"
                                ref={marqueeRef}
                                onMouseOver={() => marqueeRef.current?.stop()}
                                onMouseOut={() => marqueeRef.current?.start()}
                                style={{ pointerEvents: 'auto', marginBottom: '0' }}
                            >
                                <b>Disclaimer and Ownership:</b> {disclaimer}
                            </marquee>
                        </div>
                    </div>



                </div>

                {/* /app-Header */}
            </>
            <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
            <NotificationPreviewModal notification={previewItem} onClose={closePreview} />
        </>
    );
}
export default VisitorHeader2;

